import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { AppSettingsAppGroupIdQuietHoursRulesDataResult } from "./types";

const isWorkspaceQuietHoursRule = objectOf({
  id: string,
  channel: string,
  quiet_time_start: string,
  quiet_time_end: string,
});

export const isAppSettingsAppGroupIdQuietHoursRulesDataResult =
  objectOf<AppSettingsAppGroupIdQuietHoursRulesDataResult>({
    rules: arrayOf(isWorkspaceQuietHoursRule),
  });
